// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from "./../../../Assets/Js/helper";

import { FontAwesomeLoader } from "./FontAwesomeLoader";
import PaytourHelper, { IPaytourOptions } from "../../../Assets/Js/paytour/PaytourHelperClass";
import { ImprintHandler } from "../../../SexoleStart/Assets/Js/ImprintHandler";
import { initMobileMenu } from "../../../Assets/Js/VXProductLight/MobileMenu";
import { initCookieBanner } from "../../../Assets/Js/VXProductLight/CookieBanner";

require("./../Sass/base.scss");

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require("babel-polyfill");

helper.onWindowLoadedCompletely(() => {
	FontAwesomeLoader();
	initCookieBanner();

	const paytour = (window as any).paytourHelper;
	const wrapper = helper.$("#wrapper");
	const extender = helper.getData(wrapper, "extend");
	const sender = parseInt(helper.getData(wrapper, "host"));
	const mode: "so" | "vx" = helper.getData(wrapper, "mode");
	const coupon: string = helper.getData(wrapper, "coupon");
	const loginButton = document.querySelector(".header-buttons-login");
	const isVxWorld = window.location.host.match(/visit-x\.world/) !== null;

	let paytourSettings: IPaytourOptions = {
		lpId: "SexoleProfile",
		hideSignupConfirmation: true,
		targetUrl: "https://sexole.com/?s=" + sender + "&" + extender,
		successUrl: "https://sexole.com/?s=" + sender + "&" + extender,
		pfm: 1502,
		pfmsub: "sexolecom",
		host: sender,
		option: coupon,
		hideClose: false,
		disableJump: true,
		lang: "es",
		conversion: {
			signup: {
				background: "https://www.visit-x.net/assets/img/signup/sexole/sexole_desktop.png",
				backgroundMobile: "https://www.visit-x.net/assets/img/signup/sexole/sexole_desktop.png",
			},
		},
	};

	if (mode === "vx") {
		paytourSettings = {
			lpId: "SexoleStartVX",
			hideSignupConfirmation: true,
			targetUrl: "https://visit-x.es/es/",
			successUrl: "https://visit-x.es/es/",
			pfm: 1502,
			host: 0,
			lang: "es",
			hideClose: false,
			minAmount: 2500, // cents
			disableJump: true,
			option: coupon,
		};
	}

	const targetUrl = helper.getData(wrapper, "target");
	const ab1 = parseInt(helper.getData(wrapper, "ab1"));

	const links = helper.$(".paytour");

	for (let link of links) {
		if (!helper.hasClass(link, "nopaytour")) {
			if (isVxWorld && link === loginButton) {
				helper.addClickListener(loginButton, (evt: MouseEvent) => {
					evt.preventDefault();
					if (mode === "vx") {
						window.location.href = "https://visit-x.es/es/?vxpAutoFlow=Login&s=" + sender + "&" + extender;
					} else {
						window.location.href = "https://sexole.com/es/?vxpAutoFlow=Login&s=" + sender + "&" + extender;
					}
				});
			} else {
				helper.addEventListener(link, "click", (evt: MouseEvent) => {
					evt.preventDefault();
					switch (ab1) {
						case 2:
							window.location.href = targetUrl;
							break;
						case 1:
							paytour.openSignup(paytourSettings);
							break;
						case 0:
						default:
							paytour.openPaytour(paytourSettings);
					}
				});
			}
		}
	}

	const video = helper.$("#video");
	const videoContainer = helper.$("#videoContainer");
	const videoPlaybutton = helper.$("#videoPlay");
	const preview = helper.$("#preview");

	helper.addEventListener(video, "ended", () => {
		helper.hide(videoContainer);
		helper.show(videoPlaybutton, "flex");
		helper.show(preview);
	});

	helper.addEventListener(videoPlaybutton, "click", (evt: MouseEvent) => {
		evt.preventDefault();
		helper.show(videoContainer);
		helper.hide(videoPlaybutton);
		helper.hide(preview);
		video.play();
	});

	ImprintHandler();
	initMobileMenu();
});
